<phx-menu-button
    [phxSize]="iconSize"
    [phxDropdownTemplate]="dropdownMenu"
    [phxDropdownPosition]="isMobileView ? 'bottomLeft' : 'bottomRight'"
    phxButtonRole="secondary"
    [phxPrefixIcon]="isMobileView ? null : ellipsesIcon"
    [phxSuffixIcon]="null"
    [disabled]="isDisabled"
    >
    <span *ngIf="isMobileView" i18n>Options</span>
  </phx-menu-button>

  <phx-dropdown #dropdownMenu>
    <phx-menu>
      <ng-container *ngFor="let option of menuOptions">
        <phx-divider *ngIf="option.isOptionDivider"></phx-divider>
        <phx-menu-item *ngIf="!option.isOptionDivider"
          [class.kebab-menu-option]="!option.isDisabled"
          (click)="onOptionSelect(option)">
          <span [class.phx-web-color-content-negative-imp]="option.labelType === labelType.DANGER">{{option.label}}</span>
        </phx-menu-item>
      </ng-container>
    </phx-menu>
  </phx-dropdown>
